const isBrowser = typeof window !== 'undefined';

const setItem = (key, value) => {
  return isBrowser && localStorage.setItem(key, value);
};

const getItem = (key) => {
  let value = isBrowser ? localStorage.getItem(key) : null;
  try {
    value = JSON.parse(value);
  } catch (e) { }
  return value;
};

const clearStorage = () => {
  return isBrowser && localStorage.clear();
};

const getStorageInstance = () => {
  return isBrowser ? localStorage : null;
};

const removeItem = (key) => {
  return isBrowser && localStorage.removeItem(key);
};

const clearItemsWithPrefix = (prefix = ' ') => {
  if (!isBrowser) {
    return
  }

  const arr = [];
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i).substring(0, prefix.length) == prefix) {
      arr.push(localStorage.key(i));
    }
  }
  for (let j = 0; j < arr.length; j++) {
    localStorage.removeItem(arr[j]); 
  }
}

export default {
  setItem,
  getItem,
  clearStorage,
  getStorageInstance,
  clearItemsWithPrefix,
  removeItem,
};
